import { ReactNode } from "react";
import classNames from "classnames";
import styles from "./style.module.scss";
import { Icons } from "assets";

interface CustomAccordionProps {
  title: string;
  children: ReactNode;
  isOpen?: boolean;
  onClick?: () => void;
  renderRightContent?: ReactNode;
  isNested?: boolean;
}

const CustomAccordion = ({
  title,
  children,
  isOpen = false,
  onClick,
  renderRightContent,
  isNested = false,
}: CustomAccordionProps) => {
  return (
    <div
      className={classNames(styles.accordion, {
        [styles.active]: isOpen,
        [styles.nestedAccordion]: isNested,
      })}
    >
      <div
        className={classNames(styles.accordionHeader, {
          [styles.active]: isOpen,
        })}
        onClick={onClick}
      >
        <h4 className={(styles.title, "flex items-center gap-2")}>
          {title}
          {renderRightContent && (
            <div className="" onClick={(e) => e.stopPropagation()}>
              {renderRightContent}
            </div>
          )}
        </h4>

        <span
          className={classNames(styles.chevronIcon, {
            [styles.rotate]: isOpen,
          })}
        >
          <Icons.ChevDown />
        </span>
      </div>
      {isOpen && (
        <div className={classNames(styles.accordionContent)}>{children}</div>
      )}
    </div>
  );
};

export default CustomAccordion;
